/**
 * Fills the hidden time zone input the sign-up and login forms render, so the
 * browser's IANA zone is posted with the form. Without JavaScript the input
 * stays empty, which the server treats as no zone.
 */

import { getBrowserTimeZone } from "../utils/scheduling";

/**
 * Write the browser's time zone into every `[data-time-zone-input]`.
 *
 * A no-op when `root` holds no such input, or when the engine reports no zone
 * (assigning `undefined` to `.value` would post the string "undefined").
 *
 * @param root - where to look for the inputs
 */
export function fillTimeZoneInputs(root: ParentNode = document): void {
  const timeZone = getBrowserTimeZone();
  if (!timeZone) return;

  root
    .querySelectorAll<HTMLInputElement>("input[data-time-zone-input]")
    .forEach((input) => {
      input.value = timeZone;
    });
}
